export default __webpack_public_path__ + "static/media/sip-shubh-aarambh-mob-banner.ea4dbadc.jpg";